import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect"
import PubSub from 'pubsub-js';
import Constants, { LargeBusiness } from '../../Constants';
import { css } from 'emotion';
import { isEmpty } from 'lodash';

const EirSticky = (props) => {
  //console.log('PROPS sticky>>',props);
  const [modal, setModal] = useState(false);
  const stickyCopy = (isMobile) ? props.StickyCopyMobile : props.StickyCopy;
  const stickyBGIcon = (isMobile) ? props.StickyIconMobile : props.StickyIcon;
  const [isBusinessValid, setIsBuisinessValid] = useState(false);
  const [isLBSite] = useState(LargeBusiness.isLBSite);

  const renderContent = (content) => {
    return { __html: content };
  }
  const handleButton = (e) => {
    //when LB site, navigate to contact us page
    if (isLBSite) {
      location.href = props.redirectURL;
    } else {
      //when Mobile, directly open the dial pad
      if (isMobile) {
        let cta = document.createElement('a');
        cta.href = "tel:" + props.TelNumber;
        (isBusinessValid) ? cta.click() : location.href = (isEmpty(props.redirectURL.trim()) ? "/business/smb/contactus/" : props.redirectURL);
      } else {
        if (!isBusinessValid) {
          location.href = (isEmpty(props.redirectURL.trim()) ? "/business/smb/contactus/" : props.redirectURL);
        } else {
          setModal(true);
          PubSub.publish(Constants.eventKeys.eirModalToggled, false);
        }
      }
    }
  }
  const handleClick = () => {
    if (isMobile) {
      document.querySelectorAll(".call-sticky-modal-header .close")[0].click();
    }
  }
  const handleToggle = () => {
    setModal(!modal);
  }
  //convert time to seconds - EIR-623
  const timeToSeconds = (time) => {
    var actualTime = time.split(':');
    var totalSeconds = (+actualTime[0]) * 60 * 60 + (+actualTime[1]) * 60 + (+actualTime[2]);
    return totalSeconds;
  }
  useEffect(() => {
    setTimeout(() => {
      setIsBuisinessValid((localStorage.getItem("isBusinessValid") == "true") ? true : false);
     // if(isLBSite > 0){
       if(isBusinessValid){
        document.querySelector(".eir-sticky").classList.remove("hide");
       }
      //}
    }, 3500);

    let getParentReference = document.getElementById("sticky-ctr-" + props.StickyOccurence);
    var isIEBrowser = window.navigator.userAgent.indexOf("MSIE") > 0;
    //set the sticky icon  - variable from scss
    if (!isLBSite && !isIEBrowser && stickyBGIcon != undefined && stickyBGIcon.path.length > 0) document.documentElement.style.setProperty('--business-callus-sticky-bgicon', 'url(' + stickyBGIcon.path + ')');
    if (!isLBSite && !isIEBrowser) document.documentElement.style.setProperty('--business-sticky-right', ("-" + getParentReference.querySelector("#stickyLabel").clientWidth / 2 + "px"));
  }
  )
  // when only copy and no icon - text to be center aligned , else left aligned and min-wid-height is when only icon available- keep min widht, height
  let stickyButtonCopyAlign = (stickyBGIcon != undefined) ? "" : "min-wid-height text-center"

  let stickyButtonStyle = (css` background-color: ${props.StickyButtonBgColor}!important;`)

  const stickyClasses = isLBSite ? "eir-lb-sticky" : "";

  return (
    <div className={`eir-sticky hide `} id={"sticky-ctr-" + props.StickyOccurence}>

      <div className={(isLBSite ? `sticky-button ${stickyClasses}-container ` + stickyButtonStyle :
        (stickyCopy == undefined || stickyCopy.length == 0) ? (isMobile || isTablet) ?
          ('sticky-button-no-copy-only-icon ' + stickyButtonStyle)
          : 'sticky-button-no-copy-only-icon ' + stickyButtonStyle
          : `sticky-button  ` + stickyButtonStyle)} >
             <span id='sticky-chat'>
        <div id="stickyLabel" className={`stickyButtonCopyAlign ${stickyClasses}`} onClick={handleButton} dangerouslySetInnerHTML={renderContent(stickyCopy)}>
        </div>
        {!isLBSite && (stickyBGIcon) &&
          <a className="sticky-modal-href" 
          //href={"tel:" + props.TelNumber}
          className={'sticky-overlay'} 
          onClick={handleButton} 
          >
          <img className={((isMobile || isTablet) && (stickyCopy == undefined || stickyCopy.length == 0)) ? "mobile-only-icon" : "sticky-image"} src={stickyBGIcon.path} alt={props.StickyIconAlt} />
          </a>
        }
        {/* enabling modal on click of button */}
        <Modal
          isOpen={modal}
          toggle={handleToggle}
          className="eir-modal eir-fluid-md-w75 eir-sticky-modal-outer"
          centered={true}
        >
          <ModalHeader className={"call-sticky-modal-header icon-close--primary "} toggle={handleToggle} />
          <ModalBody className="call-sticky-modal">
            {props.CloseIcon != undefined && <img src={props.CloseIcon.path} alt="Close" className="sticky-close-icon" />}
            <span dangerouslySetInnerHTML={renderContent(props.OverlayCopy)}></span>
            {isMobile?
            <a className="sticky-modal-href" 
            href={"tel:" + props.TelNumber}
            className={'sticky-overlay'} 
            onClick={handleClick} 
            >
              <img className='overlay-img' src={props.OverlayIcon.path} alt={"call " + props.TelNumber} />
            </a>:
            <a className="sticky-modal-href" 
            className={'sticky-overlay'} 
            onClick={handleClick} 
            >
              <img className='overlay-img' src={props.OverlayIcon.path} alt={"call " + props.TelNumber} />
            </a>}
            
          </ModalBody>
        </Modal>
        </span>
      </div>
    </div >

  );
}

export default EirSticky;